import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "col-span-1 bg-white rounded-lg shadow divide-y divide-gray-200" }
const _hoisted_2 = { class: "w-full flex items-start justify-between p-6 space-x-6" }
const _hoisted_3 = { class: "items-start" }
const _hoisted_4 = { class: "flex-1" }
const _hoisted_5 = { class: "flex items-center space-x-3" }
const _hoisted_6 = { class: "text-curaduria text-md font-medium" }
const _hoisted_7 = { class: "mt-1 text-gray-500 text-sm truncate" }
const _hoisted_8 = { class: "mt-1 text-gray-500 text-sm" }
const _hoisted_9 = {
  key: 0,
  class: "overflow-x-scroll h-32 mt-2"
}
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "-mt-px flex divide-x divide-gray-200" }
const _hoisted_12 = { class: "w-0 flex-1 flex" }
const _hoisted_13 = ["href"]
const _hoisted_14 = { class: "ml-3" }


import {
  ArchiveIcon, GlobeIcon
} from "@heroicons/vue/outline";

interface Props {
  title: string | number
  description: string
  navigateTo: string
  description_large?:string
  img?:string
}


export default /*#__PURE__*/_defineComponent({
  props: {
    title: null,
    description: null,
    navigateTo: null,
    description_large: null,
    img: null
  },
  setup(__props: any) {

const props = __props as {
  title: string | number
  description: string
  navigateTo: string
  description_large?:string
  img?:string
}




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(ArchiveIcon), { class: "h-10 w-10 rounded-full flex-shrink-0 text-curaduriaDark" })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("h3", _hoisted_6, _toDisplayString(props.title), 1)
        ]),
        _createElementVNode("p", _hoisted_7, _toDisplayString(props.description), 1),
        _createElementVNode("p", _hoisted_8, _toDisplayString(props.description_large), 1),
        (props.img)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("img", {
                src: props.img,
                alt: "imagen"
              }, null, 8, _hoisted_10)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("a", {
            href: `${props.navigateTo}`,
            target: "_blank",
            class: "relative -mr-px w-0 flex-1 inline-flex items-center justify-center py-4 text-sm text-gray-700 font-medium border border-transparent rounded-bl-lg hover:text-gray-500 cursor-pointer"
          }, [
            _createVNode(_unref(GlobeIcon), {
              class: "w-5 h-5 text-gray-400",
              "aria-hidden": "true"
            }),
            _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t("resolutions.btnGoText")), 1)
          ], 8, _hoisted_13)
        ])
      ])
    ])
  ]))
}
}

})